import { render, staticRenderFns } from "./DetailsNameTable.vue?vue&type=template&id=d45650e8&scoped=true"
import script from "./DetailsNameTable.vue?vue&type=script&lang=js"
export * from "./DetailsNameTable.vue?vue&type=script&lang=js"
import style0 from "./DetailsNameTable.vue?vue&type=style&index=0&id=d45650e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45650e8",
  null
  
)

export default component.exports